import { format, parseISO } from 'date-fns';

export function fullName(c: { first_name: string; last_name: string }): string {
  return `${c.first_name} ${c.last_name}`.trim();
}

export function formatDateTime(iso: string): string {
  return format(parseISO(iso), 'EEE MMM d, yyyy · h:mm a');
}

export function formatDate(iso: string): string {
  return format(parseISO(iso), 'EEE MMM d, yyyy');
}

export function formatTime(iso: string): string {
  return format(parseISO(iso), 'h:mm a');
}

// Human duration, e.g. 90 → "1h 30m", 60 → "1h", 45 → "45m".
export function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m}m`;
}

// Loose, forgiving message extractor for Supabase / fetch errors.
export function errorMessage(err: unknown): string {
  if (!err) return 'Something went wrong.';
  if (typeof err === 'string') return err;
  if (err instanceof Error) return err.message;
  if (typeof err === 'object' && 'message' in err) {
    return String((err as { message: unknown }).message);
  }
  return 'Something went wrong.';
}
